/**
 * Resolve a multi-language content blob to a single string.
 *
 * Content columns (product_title, category title, ...) store JSON keyed by
 * UPPERCASE language code: {"EN":"...","LV":"..."}. Legacy rows may be plain
 * strings or use lowercase keys. `_meta` (added by backend auto-translation)
 * is a nested object and must be ignored.
 *
 * @param {string|object|null|undefined} content
 * @param {string} [lang='EN'] requested language code (any case)
 * @param {string} [fallback=''] returned when nothing usable is found
 * @returns {string}
 */
export const getLocalizedContent = (content, lang = 'EN', fallback = '') => {
  if (content === null || content === undefined || content === '') return fallback;

  let parsed = null;
  if (typeof content === 'object') {
    parsed = content;
  } else if (typeof content === 'string' && content.trim().startsWith('{')) {
    try {
      parsed = JSON.parse(content);
    } catch (e) {
      return content; // not JSON after all — treat as plain text
    }
  } else {
    return String(content);
  }

  const upper = String(lang).toUpperCase();
  const lower = String(lang).toLowerCase();
  const isText = (v) => typeof v === 'string' && v.length > 0;

  if (isText(parsed[upper])) return parsed[upper];
  if (isText(parsed[lower])) return parsed[lower];
  if (isText(parsed.EN)) return parsed.EN;
  if (isText(parsed.en)) return parsed.en;

  const first = Object.entries(parsed).find(([k, v]) => k !== '_meta' && isText(v));
  return first ? first[1] : fallback;
};
